/** Business labels for the email journal's `kind` identifiers. Unknown kinds fall back to the raw value. */
export const KIND_LABELS: Record<string, string> = {
  "cognito-AdminCreateUser": "Account invitation",
  "cognito-ResendCode": "Invitation resent",
  "cognito-ForgotPassword": "Password reset",
  "cognito-Authentication": "Sign-in code",
  "cognito-VerifyUserAttribute": "Email verification",
  "cognito-UpdateUserAttribute": "Email change verification",
  "cognito-AccountTakeOverNotification": "Security notice",
  "cognito-SignUp": "Sign-up confirmation",
  campaign: "Campaign",
  test: "Test send",
  unknown: "Unknown",
};

export function kindLabel(kind: string): string {
  return KIND_LABELS[kind] ?? kind;
}
